import MuiToggleButton, { ToggleButtonProps as MuiToggleButtonProps } from "@mui/material/ToggleButton";
import React, { forwardRef, FunctionComponent } from "react";
import Tooltip, { TooltipProps } from "../tooltip/Tooltip";

export interface ToggleButtonProps extends MuiToggleButtonProps {
	/** properties to apply to tooltip */
	tooltipProps?: Omit<TooltipProps, "children">;
};

const ToggleButton: FunctionComponent<ToggleButtonProps> = forwardRef((props, ref) => {
	const {
		tooltipProps,
		...toggleButtonProps
	} = props;

	const dataCsiAutomation= props.value ? `button-${props.value}` : undefined;

	return tooltipProps && !props.disabled ? (
		<Tooltip {...tooltipProps}>
			<MuiToggleButton
				data-csi-automation={dataCsiAutomation}
				data-testid="ToggleButton"
				ref={ref}
				{...toggleButtonProps}
			/>
		</Tooltip>
	)
		: (
			<MuiToggleButton
				data-csi-automation={dataCsiAutomation}
				data-testid="ToggleButton"
				ref={ref}
				{...toggleButtonProps}
			/>
		);
});

export default ToggleButton;
